import './block-pager.css';
